jQuery(document).ready(function ($) {
  // 使用事件委托来监听所有可能的点击

  // 限定在当前产品价格容器内读取，避免读到其他产品卡片的价格
  const $productPrice = $(".product__price .price");

  // 划线原价：s 标签本身有 price-item--regular 这个 class
  const $strikethroughEl = $productPrice.find("s.price-item--regular");

  // 现价
  const $salePriceEl = $productPrice.find(".price-item--sale.price-item--last");

  // 无折扣时的价格
  const $regularOnlyEl = $productPrice.find(".price__regular .price-item--regular");

  if ($strikethroughEl.length > 0) {
      originalVariantRegularPrice = parseFloat($strikethroughEl.first().text().replace(/[^0-9.]/g, '')) || 0;
      originalVariantSalePrice = parseFloat($salePriceEl.first().text().replace(/[^0-9.]/g, '')) || 0;
  } else {
      originalVariantRegularPrice = parseFloat($regularOnlyEl.first().text().replace(/[^0-9.]/g, '')) || 0;
      originalVariantSalePrice = originalVariantRegularPrice;
  }

  console.log('初始原价(划线):', originalVariantRegularPrice, '初始售价:', originalVariantSalePrice);

  let originalQuantity = 1;
  var productInputs = {};
  //产品详情页价格获取
  var $initPrice = $(".product__price .price .price-item").html();
  //获取元字段数据
  const metafieldsJson = document.getElementById("product-metafields");
  let metafields = {};
  if (metafieldsJson) {
        metafields = JSON.parse(metafieldsJson.textContent);
    }

  function updatePriceDisplay(newPrice, inputs, mode) {
    const $priceWrapper = $(".product__price .price");
    const hasDiscount =
      $priceWrapper.find("del").length > 0 &&
      $priceWrapper.find("ins").length > 0;
    const quantity = inputs.quantity || 1;
    // const unitPrice = newPrice / quantity;
    const unitPrice = newPrice;
    function formatPrice(price) {
		//price = price*quantity;
      return (
        '<span class="woocommerce-Price-currencySymbol">$</span>' +
        price.toFixed(2)
      );
    }

    // 使用页面加载时保存的原始价格计算折扣比例
    const discountRatio = (originalVariantRegularPrice > 0 && originalVariantSalePrice > 0 && originalVariantSalePrice < originalVariantRegularPrice)
      ? originalVariantSalePrice / originalVariantRegularPrice
      : 1;

    const calculatedSalePrice = newPrice;
    const calculatedRegularPrice = discountRatio < 1
      ? newPrice / discountRatio
      : 0;

    function updatePriceHtml(regularPrice, salePrice) {
      if (inputs.panelType === "Split Panels") {
        return `${quantity}  × ${formatPrice(salePrice)}`;
      } else {
		  if(salePrice>0){
        if(quantity > 1){
          panel = 'pieces';
        }else{
          panel = 'Piece';
        }
			 	return `${quantity} ${panel} × ${formatPrice(salePrice)}`;
			 }else{
			 	return $initPrice;
			 }
        //return formatPrice(salePrice);
      }
    }

    console.log(newPrice, calculatedRegularPrice);

    if (discountRatio < 1 && calculatedRegularPrice > 0) {
      $priceWrapper.removeClass('price--no-sale').addClass('price--on-sale');
      $priceWrapper.find('s.price-item--regular').html(formatPrice(calculatedRegularPrice));
      $priceWrapper.find('.price__sale .price-item--sale').html(updatePriceHtml(0,calculatedSalePrice));
      const saveAmount = calculatedRegularPrice - calculatedSalePrice;
      $priceWrapper.find('.price__badge-sale').text('Save $' + saveAmount.toFixed(2));
    } else {
      $priceWrapper.removeClass('price--on-sale').addClass('price--no-sale');
      $priceWrapper.find('.price__regular .price-item--regular').html(updatePriceHtml(0,calculatedSalePrice));
    }

    // 更新其他显示元素
    $("#fetch_color_res_txt").html(inputs.colorSwatch || "");
    $("#fetch_width_res_txt").html(
      inputs.width ? inputs.width.toFixed(2) + '"' : ""
    );
    $("#fetch_length_res_txt").html(
      inputs.height ? inputs.height.toFixed(2) + '"' : ""
    );
    $("#fetch_header_res_txt").html(inputs.header || "");
    $("#fetch_lining_res_txt").html(inputs.lining || "");
  }

  function handleCurtainCalculation(isAddToCart = false, updatePriceStr = "") {
    // 获取所有必要的输入值
    const inputs = {
      productId: $('input[name="product-id"]').val(),
      variation_id: $('input[name="id"]').val() || 0,
      colorSwatch: $(".variant-picker__color").val() || "",
      method: $('input[name="mtsi_method"]:checked').val(),
      header: $('input[name="mtsi_header_type"]:checked').val(),
      width: parseFloat($("#mtsi_custom_curtain_width").val()),
      height: parseFloat($("#mtsi_custom_curtain_height").val()),
      width_eighths: $("select[name='width_eighths']").val(),
      height_eighths: $("select[name='height_eighths']").val(),
      unit: 'inches',
      panelType: $('input[name="mtsi_panel_type"]:checked').val(),
      mountType: $('input[name="mtsi_mount_type"]:checked').val(),
      liftControl: $('input[name="mtsi_lift_control"]:checked').val(),
      liningOption: $('input[name="mtsi_lining_option"]:checked').val(),
      quantity: parseInt($('.quantity input[name="quantity"]').val() || "1"),
      lining: $('input[data-name="mtsi_custom_curtain_lining"]:checked').val(),
      liningColor:
        $('input[data-name="mtsi_liner_color_swatch"]:checked').attr(
          "data-color-name"
        ) || "",
      linerUnitPrice: parseFloat(metafields.liner_unit_price) || 0,
      fabricUnitPrice: parseFloat(metafields.fabric_unit_price) || 0,
      gramPerSquareInches:
        parseFloat(metafields.gram_per_square_inches) || 0,
      linerGramPerSquareInches:
        parseFloat(metafields.liner_gram_per_square_inches) || 0,
      patternType: "vertical",
      exchangeRate: parseFloat(1/7.0),
      startValue: 'YES',
    };
    productInputs = inputs;
    // 分离面板的宽度调整,处理Split Panels的数量调整
    if (updatePriceStr != "") {
      if (inputs.panelType == "Split Panels") {
        inputs.quantity *= 2;
      }
    } else {
      if (inputs.panelType === "Split Panels") {
        if (inputs.quantity * 2 == originalQuantity) {
          inputs.quantity *= 2;
        }
      } else {
        if (inputs.quantity === originalQuantity) {
          inputs.quantity = originalQuantity;
          $('input[name="quantity"]').val(inputs.quantity);
        }
      }
    }
    
   
    //获取宽度
    let craftWidth = inputs.width;
    //获取高度
    let craftheight = inputs.height;
    //计算面料的平方米 宽*高*0.00064516
    let square_meters = craftWidth * craftheight * 0.00064516;
    console.log("square_meters:" + square_meters);
    //一平方米起订，不足一平方米强制等于1平方米
    if(square_meters < 1){
      square_meters = 1;
    }
    console.log("square_meters1:" + square_meters);
    //面料成本计算，面料型号每inch成本 *（宽inch + 7.87）
    let fabricPrice = inputs.fabricUnitPrice * (craftWidth + 7.87);
    console.log("fabricPrice:" + fabricPrice);
    //加工费计算，系统型号加工费RMB * 平方米
    let processing_fee = 95 * square_meters;
    console.log("processing_fee:" + processing_fee);

    //电机款特有的成本
    //电机价格
    let motor_price = 180;
    //轨道价格 = 宽inch*0.0254*35；
    let track_price = craftWidth * 0.0254 *35;
    console.log("track_price:" + track_price);
    //重量 = 1.2kg*每平方米 + 0.3
    let fabric_weight = 1.2 * square_meters + 0.3;
    console.log("fabric_weight:" + fabric_weight);
    //判断是否电机款
    if(inputs.liftControl === 'Motorized'){
      //重量 = 1.5kg*每平方米 + 0.4
      fabric_weight = 1.5 * square_meters + 0.4;
      console.log("fabric_weight1:" + fabric_weight);
    }
    console.log("fabric_weight1+1:" + fabric_weight);
    //重量取整，按照0.5向上取整
    fabric_weight = Math.ceil(fabric_weight * 2) / 2;
    console.log("fabric_weight2:" + fabric_weight);

    //2025-11-05更新，罗马帘宽度 <= 39 inch 即为正常合同
    const shippingData = {
        "0.5": 166.6535,
        "1.0": 183.937,
        "1.5": 201.3765,
        "2.0": 243.542,
        "2.5": 285.4735,
        "3.0": 310.141,
        "3.5": 349.1605,
        "4.0": 388.18,
        "4.5": 427.1995,
        "5.0": 466.219,
        "5.5": 452.8225,
        "6.0": 487.89,
        "6.5": 522.9575,
        "7.0": 558.025,
        "7.5": 593.0925,
        "8.0": 628.16,
        "8.5": 663.2275,
        "9.0": 698.295,
        "9.5": 733.3625,
        "10.0": 768.43,
        "10.5": 893.4445,
        "11.0": 930.475,
        "11.5": 967.5055,
        "12.0": 1004.536,
        "12.5": 1041.5665,
        "13.0": 1078.597,
        "13.5": 1115.6275,
        "14.0": 1152.658,
        "14.5": 1189.6885,
        "15.0": 1226.719,
        "15.5": 1263.7495,
        "16.0": 1300.78,
        "16.5": 1337.8105,
        "17.0": 1374.841,
        "17.5": 1411.8715,
        "18.0": 1448.902,
        "18.5": 1485.9325,
        "19.0": 1522.96,
        "19.5": 1559.99,
        "20.0": 1597.02,
        "20.5": 1871.45,
        "21.0": 1902.36,
        "21.5": 1933.26,
        "22.0": 1964.17,
        "22.5": 1995.08,
        "23.0": 2025.99,
        "23.5": 2056.89,
        "24.0": 2087.80,
        "24.5": 2118.71,
        "25.0": 2149.62,
        "25.5": 2180.52,
        "26.0": 2211.43,
        "26.5": 2242.34,
        "27.0": 2273.25,
        "27.5": 2304.15,
        "28.0": 2335.06,
        "28.5": 2365.97,
        "29.0": 2396.88,
        "29.5": 2427.78,
        "30.0": 2458.69
    };
    //罗马帘宽度 > 39 inch 即为超长；超长用《超长运费合同》
    const shippingExtraLongData = {
        "0.5": 368.1535,
        "1.0": 385.437,
        "1.5": 402.8765,
        "2.0": 445.042,
        "2.5": 486.9735,
        "3.0": 511.641,
        "3.5": 550.6605,
        "4.0": 589.68,
        "4.5": 628.6995,
        "5.0": 667.719,
        "5.5": 654.3225,
        "6.0": 689.39,
        "6.5": 724.4575,
        "7.0": 759.525,
        "7.5": 794.5925,
        "8.0": 829.66,
        "8.5": 864.7275,
        "9.0": 899.795,
        "9.5": 934.8625,
        "10.0": 969.93,
        "10.5": 1094.9445,
        "11.0": 1131.975,
        "11.5": 1169.0055,
        "12.0": 1206.036,
        "12.5": 1243.0665,
        "13.0": 1280.097,
        "13.5": 1317.1275,
        "14.0": 1354.158,
        "14.5": 1391.1885,
        "15.0": 1428.219,
        "15.5": 1465.2495,
        "16.0": 1502.28,
        "16.5": 1539.3105,
        "17.0": 1576.341,
        "17.5": 1613.3715,
        "18.0": 1650.402,
        "18.5": 1687.4325,
        "19.0": 1724.46,
        "19.5": 1761.49,
        "20.0": 1798.52,
        "20.5": 2072.95,
        "21.0": 2103.86,
        "21.5": 2134.76,
        "22.0": 2165.67,
        "22.5": 2196.58,
        "23.0": 2227.49,
        "23.5": 2258.39,
        "24.0": 2289.30,
        "24.5": 2320.21,
        "25.0": 2351.12,
        "25.5": 2382.02,
        "26.0": 2412.93,
        "26.5": 2443.84,
        "27.0": 2474.75,
        "27.5": 2505.65,
        "28.0": 2536.56,
        "28.5": 2567.47,
        "29.0": 2598.38,
        "29.5": 2629.28,
        "30.0": 2660.19
    };
    //运费RMB = 根据重量匹配运费合同中的运费
    console.log("freight+++++:" + fabric_weight.toFixed(1));
    let freight = shippingData[fabric_weight.toFixed(1)];
    //宽度大于39，使用超长运费合同
    if(craftWidth > 39){
      freight = shippingExtraLongData[fabric_weight.toFixed(1)];
    }
    
    console.log("freight:" + freight);
    var totalPrice = 0;
    
    if(inputs.liftControl === 'Motorized'){
    //所有成本 = 面料成本RMB + 加工费RMB + 运费RMB + 电机价格 + 轨道价格
    totalPrice = fabricPrice + processing_fee + freight + motor_price + track_price;
    console.log('所有成本1'+totalPrice);
    }else{
    //所有成本 = 面料成本RMB + 加工费RMB + 运费RMB
    totalPrice = fabricPrice + processing_fee + freight;
    console.log('所有成本2'+totalPrice);
    }

    //定价 = 所有成本 * 利润系数 / 7.2 
    //20260226 利润系数从4倍改成2倍
    //20260322 利润系数从2倍改成4倍
    //20260413 利润系数从4倍改成2.5倍
    totalPrice = (totalPrice * 2.5) /7;

    //判断如果选择衬布，总价 * 1.2
    console.log('衬布'+inputs.liningColor);
    console.log('衬布22'+inputs.lining);
    if (inputs.lining && "Unlined" !== inputs.lining && "Unlined-lining" !== inputs.lining) {
            totalPrice *= 1.2;
    }
    //全站涨价10%
    //totalPrice = totalPrice * 1.1;
    
    console.log('定价'+totalPrice);
    totalPrice = Math.floor(totalPrice * 100) / 100;

    inputs.totalPrice = totalPrice;

    //传递数值到隐藏表单，提交到购物车
    document.getElementById('hiddenMountType').value = inputs.mountType ?? '';
    document.getElementById('hiddenWidth').value = inputs.width + ' ' + inputs.width_eighths + '"' ?? '';
    document.getElementById('hiddenHeight').value = inputs.height + ' ' + inputs.height_eighths + '"' ?? '';
    document.getElementById('hiddenLiftControl').value = inputs.liftControl ?? '';
    document.getElementById('hiddenLining').value = inputs.lining ?? '';
    document.getElementById('hiddenLinerColor').value = inputs.liningColor ?? '';
    var appPriceInput = document.getElementById('custom-price-field');

    if (appPriceInput) {
        appPriceInput.value = totalPrice;
    }

    $(".new-xqy .color").html(inputs.colorSku);
    $(".new-xqy .mountType").html(inputs.mountType); 
    $(".new-xqy .liftControl").html(inputs.liftControl);
    $(".new-xqy .lining").html(inputs.lining);
    if(inputs.width && inputs.height){
      $(".width_height_html").html(inputs.width + ' '+ inputs.width_eighths +'"W x ' + inputs.height + ' '+inputs.height_eighths +'"L');
      $('.kuangao').css('border','none');      
    }else{
      $(".width_height_html").html('');
      $('.kuangao').css('border','1px dashed red');
    }
    if(inputs.mountType == 'Inside'){
      $('.kuangao-img img').attr("src", 'https://cdn.shopify.com/s/files/1/0752/7399/4425/files/Inside-Mount-measuring-min.png?v=1766975679');
      $('.note-text').html('. Width: Measure widths at top, middle, and bottom inside the window; use the smallest one & deduct 3/8".<br> · Length: Measure heights at left, center, right inside the window; use the largest measurement.');
      $('input[value="Cordless"]').siblings('span').find('img')
        .attr('src', 'https://cdn.shopify.com/s/files/1/0752/7399/4425/files/Inside-Mount-manual-cordless-min.png?v=1766742344');
      $('input[value="Motorized"]').siblings('span').find('img')
        .attr('src', 'https://cdn.shopify.com/s/files/1/0752/7399/4425/files/Inside-Mount-motorized-min.png?v=1766742381');
    }else if(inputs.mountType == 'Outside'){
      $('.kuangao-img img').attr("src", 'https://cdn.shopify.com/s/files/1/0752/7399/4425/files/Outside-Mount-measuring-min.png?v=1766975874');
      $('.note-text').html('· Width: Measure widths at top, middle, and bottom inside the window; use the largest one and add  2-4 inches for optimal coverage.<br> · Height: Measure from your desired mounting point down to the desired bottom. Recommend: 4-6 inches above the window frame.');
      $('input[value="Cordless"]').siblings('span').find('img')
        .attr('src', 'https://cdn.shopify.com/s/files/1/0752/7399/4425/files/Outside-Mount-manual-cordless-min.png?v=1766975915');
      $('input[value="Motorized"]').siblings('span').find('img')
        .attr('src', 'https://cdn.shopify.com/s/files/1/0752/7399/4425/files/Outside-Mount-motorized-min.png?v=1766975945');
    }
    checkAllOptionsSelected();
    if(totalPrice){
    updatePriceDisplay(totalPrice, inputs, inputs.startValue);
    }
  }
  //初始化计算
  handleCurtainCalculation();
  //分界线
  function checkAllOptionsSelected() {
    var allSelected = true;

    if (!productInputs.mountType || !productInputs.liftControl) {
      allSelected = false;
    }

    // Check if width and height are entered and valid
    var minwidthValue = 10;
    var minheightValue = 20;
    var maxValue = 97;
    if (!(productInputs.width && productInputs.width >= minwidthValue && productInputs.width <= maxValue && productInputs.height && productInputs.height >= minheightValue && productInputs.height <= maxValue)) {
      allSelected = false;
    }

    // 根据 value 定位
    let cordlessOption = document.querySelector('input[type="radio"][name="mtsi_lift_control"][value="Cordless"]');
    let motorizedOption = document.querySelector('input[type="radio"][name="mtsi_lift_control"][value="Motorized"]');

    // 父级 span（用于插入提示）
    let cordlessWrapper = cordlessOption.closest(".wpcf7-list-item");
    let motorizedWrapper = motorizedOption.closest(".wpcf7-list-item");

    // 删除旧的提示
    document.querySelectorAll(".option-warning").forEach(el => el.remove());

    // Cordless 限制
    if ((Number(productInputs.width) < 10 || Number(productInputs.width) > 97) || (Number(productInputs.height) < 20 || Number(productInputs.height) > 94)) {
        cordlessOption.disabled = true;
        //cordlessOption.checked = false;

        //let warning = document.createElement("div");
        //warning.className = "option-warning";
        //warning.style.color = "red";
        //warning.textContent = "Cordless option is unavailable for widths over 94 inches.";
        //cordlessWrapper.insertAdjacentElement("beforebegin", warning);
    } else {
        cordlessOption.disabled = false;
        console.log('cordless 占位');
        //cordlessOption.checked = true;
    }

    // Motorized 限制
    if ((Number(productInputs.width) < 24 || Number(productInputs.width) > 97) || (Number(productInputs.height) < 20 || Number(productInputs.height) > 97)) {
        motorizedOption.disabled = true;
        //motorizedOption.checked = false;

    } else {
        motorizedOption.disabled = false;
        console.log('motorized 占位');
        //motorizedOption.checked = true;
    }

    var $addToCartButton = $(".product-form__submit");
    if (allSelected) {
      $addToCartButton.prop("disabled", false);
      $addToCartButton.removeClass("disabled");
    } else {
      $addToCartButton.prop("disabled", true);
      $addToCartButton.addClass("disabled");
    }
    return allSelected;
  }

  //加入购物车，已弃用
  function addToCart(adjustedInputs, totalPrice) {
    // 检查是否所有必要的字段都已填写
    if (
      !adjustedInputs.mountType ||
      !adjustedInputs.liftControl ||
      isNaN(adjustedInputs.width) ||
      isNaN(adjustedInputs.height)
    ) {
      alert("Please fill in all required fields!");
      return;
    }

    if (!adjustedInputs.colorSwatch) {
      alert("Please choose a color");
      return false;
    }
    const cartData = {
      action: "cstm_add_to_cart",
      product_id: adjustedInputs.productId,
      variation_id: adjustedInputs.variation_id,
      msti_pattern_type: adjustedInputs.patternType,
      mtsi_color_sku: adjustedInputs.colorSku,
      mtsi_color_swatch: adjustedInputs.colorSwatch,
      mtsi_mount_type: adjustedInputs.mountType,
      mtsi_lift_control: adjustedInputs.liftControl,
      mtsi_custom_curtain_width: adjustedInputs.width,
      mtsi_custom_curtain_height: adjustedInputs.height,
      width_eighths: adjustedInputs.width_eighths,
      height_eighths: adjustedInputs.height_eighths,
      mtsi_custom_curtain_unit: adjustedInputs.unit,
      quantity: adjustedInputs.quantity,
      mtsi_custom_curtain_lining: adjustedInputs.lining,
      mtsi_custom_curtain_lining_color: adjustedInputs.liningColor,
      security: ajax_object.nonce,
      calculated_price: totalPrice,
      startValue: adjustedInputs.startValue,
    };

    $.ajax({
      url: ajax_object.ajax_url,
      type: "POST",
      data: cartData,
      beforeSend: function () {
        var $addToCartButton = $(".single_add_to_cart_button");
        $addToCartButton.prop("disabled", true);
        $addToCartButton.addClass("disabled");
      },
      success: function (response) {
        if (response.success) {
          localStorage.setItem("NEWCARTADDITEM", "1");
          location.reload();
        } else {
          alert(response.data.msg);
          var $addToCartButton = $(".single_add_to_cart_button");
          $addToCartButton.prop("disabled", false);
          $addToCartButton.removeClass("disabled");
        }
      },
      error: function (xhr, status, error) {
        alert("An error occurred: " + error);
        var $addToCartButton = $(".single_add_to_cart_button");
        $addToCartButton.prop("disabled", false);
        $addToCartButton.removeClass("disabled");
      },
    });
  }

  var $addToCartButton = $(".single_add_to_cart_button");
  $addToCartButton.on("click", function (e) {
    handleCurtainCalculation(false);
    e.preventDefault();
    addToCart(productInputs, productInputs.totalPrice);
  });
  //加入购物车到此结束

  $('input[name="mtsi_mount_type"] , input[name="mtsi_lift_control"] ,input[data-name="mtsi_custom_curtain_lining"], #mtsi_custom_curtain_width , #mtsi_custom_curtain_height , select[name="width_eighths"] , select[name="height_eighths"], .quantity input.quantity__input').on("change", function () {
    handleCurtainCalculation(false);
  });

    //变体颜色切换会把价格更改成变体价格，需要等待shopify的更改价格函数执行后，才可以触发更改价格
    $('input[name="Color"]').on("change", function () {        
    setTimeout(() => {
        const $productPrice = $(".product__price .price");
        const $newStrikethrough = $productPrice.find("s.price-item--regular");
        const $newSalePrice = $productPrice.find(".price-item--sale.price-item--last");
        
        if ($newStrikethrough.length > 0) {
            originalVariantRegularPrice = parseFloat($newStrikethrough.first().text().replace(/[^0-9.]/g, '')) || 0;
            originalVariantSalePrice = parseFloat($newSalePrice.first().text().replace(/[^0-9.]/g, '')) || 0;
        } else {
            originalVariantRegularPrice = parseFloat($productPrice.find(".price__regular .price-item--regular").first().text().replace(/[^0-9.]/g, '')) || 0;
            originalVariantSalePrice = originalVariantRegularPrice;
        }
        console.log('变体切换后 - 原价:', originalVariantRegularPrice, '售价:', originalVariantSalePrice);
        handleCurtainCalculation(false);
    }, 1000);
    });

  $('#mtsi_custom_curtain_width , #mtsi_custom_curtain_height').keypress(function(event){
    handleCurtainCalculation(false);
    if (event.which === 13) {
      event.preventDefault();
    }
  })
  //失去焦点时
  $('#mtsi_custom_curtain_width , #mtsi_custom_curtain_height').blur(function(){
          if($("#mtsi_custom_curtain_width").val()){
            $('.wpcf7-not-valid-tip1').css('visibility','hidden');
          }else{
            $('.wpcf7-not-valid-tip1').css('visibility','visible');
          }
          if($("#mtsi_custom_curtain_width").val() && $("#mtsi_custom_curtain_width").val() < 10 || $("#mtsi_custom_curtain_width").val() > 97){
            $('.wpcf7-not-valid-tip-min').css('display','block');
            $('.wpcf7-not-valid-tip1').css('display','none');
          }else{
            $('.wpcf7-not-valid-tip-min').css('display','none');
            $('.wpcf7-not-valid-tip1').css('display','initial');
          }
          if($("#mtsi_custom_curtain_height").val()){
            $('.wpcf7-not-valid-tip2').css('visibility','hidden');
          }else{
            $('.wpcf7-not-valid-tip2').css('visibility','visible');
          }
          if($("#mtsi_custom_curtain_height").val() && $("#mtsi_custom_curtain_height").val() < 10 || $("#mtsi_custom_curtain_height").val() > 97){
            $('.wpcf7-not-valid-tip-max').css('display','block');
            $('.wpcf7-not-valid-tip2').css('display','none');
          }else{
            $('.wpcf7-not-valid-tip-max').css('display','none');
            $('.wpcf7-not-valid-tip2').css('display','initial');
          }
    handleCurtainCalculation(false);
  });

  var exec5 = 0;

  setTimeout(function () {
    if (exec5 == 0) {
      exec5 = 1;

      if (localStorage.getItem("NEWCARTADDITEM")) {
        $(".lakit-cart__heading-link").click();

        localStorage.removeItem("NEWCARTADDITEM");
      }

      if (
        $("form.woocommerce-checkout ul.uael-order-review-table li + a")
          .length
      ) {
        $(
          "form.woocommerce-checkout ul.uael-order-review-table li.table-row.cart_item.st-item-meta > a:first-child"
        ).remove();

        $("form.woocommerce-checkout ul.uael-order-review-table li + a").each(
          function () {
            $(this).remove();
          }
        );
      }
    }
  }, 1500);

});
